import { NativeSelect } from "@mui/material";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import { CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";
import { Accessor } from "static";

const Table: TablizoSchema[] = [
  {
    label: "Date",
    name: "recTime",
    type: "dateTime",
    transform: "datetime",
    dateFormat: "DD MMM YYYY",
    filterable: true,
  },
  {
    label: "Answer ID",
    name: "answerID",
    filterable: true,
  },
  {
    label: "Language",
    name: "language",
    filterable: true,
  },
  {
    label: "Category",
    name: "category",
    filterable: true,
  },
  {
    label: "Count",
    name: "count",
    valueGetter: (row, field, addOns) => {
      let count = Accessor.Get(row, "count");
      return count !== undefined ? count : "";
    },
  },
];

const Info: FormizoSchema[] = [
  {
    label: "Date",
    name: "recTime",
  },
  {
    label: "Answer ID",
    name: "answerID",
  },
  {
    label: "Language",
    name: "language",
  },
  {
    label: "Category",
    name: "category",
  },
  {
    label: "Count",
    name: "count",
  },
];

const Filterables: Filterable[] = [
  {
    label: "Answer ID",
    field: "answerID",
    type: FieldType.text,
  },
  {
    label: "Language",
    field: "language",
    type: FieldType.text,
  },
  {
    label: "Category",
    field: "category",
    type: FieldType.text,
  },
];

const Export = [
  //TODO:
  {
    label: "Date",
    name: "recTime",
  },
  {
    label: "Answer ID",
    name: "answerID",
  },
  {
    label: "Language",
    name: "language",
  },
  {
    label: "Category",
    name: "category",
  },
  {
    label: "Count",
    name: "count",
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Info,
  Export,
  AdvFilter,
  Filterables,
};

export default schema;
